import * as React from "react";
import { IInputFieldProps } from "~/components/Form";
import { classByIntent } from "~/lib/intent";
import style from "./index.module.scss";

export interface IRadioProps
    extends IInputFieldProps<string>,
    Omit<React.HTMLAttributes<HTMLInputElement>, "onChange"> {
    optionValue: string;
    label?: string;
}

export function RadioInput({
    id,
    disabled,
    value,
    onChange,
    optionValue,
    intent,
    className,
    label,
}: IRadioProps) {
    const classes = [style.radio, classByIntent(intent), className].filter(Boolean).join(" ");
    const checked = value === optionValue;
    const inputId = `${id ?? "radio"}-${optionValue}`;

    return (
        <div className={classes}>
            <input
                type="radio"
                id={inputId}
                name={id}
                value={optionValue}
                checked={checked}
                disabled={disabled}
                onChange={() => onChange?.(optionValue)}
                className={style.radioInput}
            />
            <label htmlFor={inputId} className={style.radioLabel}>
                <i className={`far fa-${checked ? "dot-circle" : "circle"}`} />
                {label && <span className={style.radioText}>{label}</span>}
            </label>
        </div>
    );
}
